import { CardActionsImage } from "domains/assets/components/CardActions";
import useAssetView from "domains/assets/hooks/useAssetView";
import { PersistedStateKey } from "domains/commons/hooks/usePersistedState";
import FileManagerImage, {
  FileManagerImageProps,
} from "domains/file-manager/components/FileManagerImage";
import { FileImageType } from "domains/file-manager/interfaces";

import { Box, Center, Flex, Spinner, Text } from "@chakra-ui/react";

interface ModelShowImagesExamplesProps {
  contentScrollRef?: React.RefObject<HTMLDivElement>;
  files: FileImageType[];
  ids: string[];
  onCardPinClick?: FileManagerImageProps["onCardPinClick"];
  isLoading: boolean;
}

export default function ModelShowImagesExamples({
  contentScrollRef,
  files,
  ids,
  onCardPinClick,
  isLoading,
}: ModelShowImagesExamplesProps) {
  const fmViewProps = useAssetView({ options: ["masonry", "fill", "fit"] });

  if (isLoading) {
    return (
      <Center>
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!files.length) {
    return null;
  }

  return (
    <Box pb={9}>
      <Flex direction="column" pt="0" data-testid="asset-gallery">
        <FileManagerImage
          files={files}
          isLoading={isLoading}
          settingsCacheKey={PersistedStateKey.FILE_MANAGER_MODEL_EXAMPLES}
          isSelectable
          isWithoutAssetZoom
          CardActionsComponent={CardActionsImage}
          headerLeftContent={<Text size="title.md">Pinned</Text>}
          {...fmViewProps}
          scrollRef={contentScrollRef}
          pinnedFileIds={onCardPinClick ? ids : undefined}
          onCardPinClick={onCardPinClick}
        />
      </Flex>
    </Box>
  );
}
